import { Button } from "primereact/button"
import { Column } from "primereact/column"
import { DataTable } from "primereact/datatable"
import { InputText } from "primereact/inputtext"
import { ProgressSpinner } from "primereact/progressspinner"
import { Toast } from "primereact/toast"
import { failureToast, successToast } from "../Common/CommonFunctions";
import { useContext, useEffect, useRef, useState } from "react"
import { CommonBodyForTable, srBodyTemplate } from "../Common/CommonComponents"
import { permissionContext } from "../../AppWrapper"
import ApiServices from "../../service/api/ApiServices"
import { Dialog } from "primereact/dialog"

const apiServices = new ApiServices();

export const GSFProductMaster = () => {
    const [productList, setProductslist] = useState(null)
    const [loading, setLoading] = useState(false)
    const [globalFilter, setGlobalFilter] = useState('');
    const [deleteZohoId, setDeleteZohoId] = useState()
    const [confirmDeleteDialog, setConfirmDeleteDialog] = useState(false)

    const toast = useRef(null);
    const dataRef = useRef(null);

    useEffect(() => {
        getGSFProducts();
    }, []);

    const rolePermissions = useContext(permissionContext);

    const exportCSV = () => {
        dataRef.current.exportCSV();
    }

    const header = (
        <div className="table-header">
            <span className="p-input-icon-right">
                <h6 className="p-mt-3 p-mr-5">Products</h6>
            </span>
            <span className="p-input-icon-left">
                <div className="p-inputgroup">
                    <Button className='custom-group-btn' icon="pi pi-search" />
                    <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
                    <Button className='custom-group-btn p-button-rounded p-m-2' onClick={() => { exportCSV(dataRef) }} icon="pi pi-download"></Button>
                </div>
            </span>
        </div>
    )

    const tableStyle = { overflowX: 'scroll', width: '100%' };

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <span className="p-column-title">Actions</span>
                <div className="actions" style={{ display: "flex" }}>
                    <Button icon='pi pi-trash' title='Delete PreOrder' className="p-button-rounded p-button-danger p-mx-2" aria-label="Delete PreOrder" onClick={() => { openDeleteDialog(rowData) }} />
                </div>
            </>
        );
    }

    const deleteProduct = async () => {
        setConfirmDeleteDialog(false);
        const response = await apiServices.deleteGsfProduct({ zoho_id: deleteZohoId })
        if (response?.data?.response_message === 'SUCCESS') {
            successToast(toast, "Product deleted successfully");
            setGlobalFilter('')
            getGSFProducts();
        } else {
            failureToast(toast, "Failed to delete")
        }
    }

    const deleteDialogFooter = () => {
        return (
            <>
                <Button label="Yes, Delete it" icon='pi pi-check' className="p-button-success" onClick={() => { deleteProduct(deleteZohoId) }} />
                <Button label="Cancel" icon='pi pi-check' className="p-button-danger" onClick={() => { setConfirmDeleteDialog(false) }}></Button>
            </>
        )
    }

    const openDeleteDialog = async (data) => {
        setConfirmDeleteDialog(true)
        setDeleteZohoId(data.zoho_id);
    }

    const getGSFProducts = async () => {
        setLoading(true);
        let response = await apiServices.getGSFProducts();
        response = response?.data.response_obj;
        setProductslist(response || []);
        setLoading(false);
    };

    return (
        <>
            <div className="p-grid crud-demo">
                <div className="p-col-12">
                    <Toast ref={toast} position="center" />
                    {
                        loading ?
                            <>
                                <div className="spinner-div">
                                    <center><ProgressSpinner strokeWidth="7" animationDuration='4s' /></center>
                                </div>
                            </>
                            :
                            <>
                                {/* <Toolbar className="p-mb-4 p-toolbar" right={rightToolbarTemplate}></Toolbar> */}
                                <DataTable style={tableStyle} className="datatable-responsive" paginator rows={10} rowsPerPageOptions={[5, 10, 25]}
                                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Records"
                                    value={productList} dataKey="id" exportFilename={`Products`}
                                    loading={loading} globalFilter={globalFilter} filterDisplay="menu" header={header} ref={dataRef}>
                                    <Column field="srid" header="Sr.No." body={srBodyTemplate} style={{ width: '1rem' }} exportable={false}></Column>
                                    <Column field="name" header="Product Name" body={CommonBodyForTable} style={{ width: '4rem' }} exportable={true} sortable></Column>
                                    <Column field="zoho_id" header="Zoho Id" body={CommonBodyForTable} style={{ width: '4rem' }} exportable={true} sortable></Column>
                                    <Column field="brand" header="Product Brand" body={CommonBodyForTable} style={{ width: '4rem' }} exportable={true} sortable></Column>
                                    <Column field="status" header="Product Status" body={CommonBodyForTable} style={{ width: '4rem' }} exportable={true} sortable></Column>
                                    <Column field="prices.list_price" header="Product Price" body={(rowData) => `${rowData.prices.list_price}`} style={{ width: '4rem' }} exportable={true} sortable></Column>
                                    <Column field="net_weight" header="Product Net Weight" body={CommonBodyForTable} style={{ width: '4rem' }} exportable={true} sortable></Column>
                                    {rolePermissions?.deleteGsfProduct && <Column field="action" body={actionBodyTemplate} header="Actions" style={{ width: '2rem' }} exportable={false}></Column>}
                                </DataTable>
                            </>
                    }
                    <Dialog visible={confirmDeleteDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteDialogFooter} onHide={(e) => { setConfirmDeleteDialog(false) }}>
                        <div className="confirmation-content">
                            <center>
                                <i className="pi pi-exclamation-triangle p-error" style={{ fontSize: '4rem' }} /><br /><br />
                                <b><span>Are you sure you want to delete this product ?</span></b> <br /><br />                            </center>
                        </div>
                    </Dialog>
                </div>
            </div>
        </>
    )
}
